
const PageError = () => {
  return (
    <div>
      Page Error
    </div>
  );
};

export default PageError;
